import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "card-header status-header" };
const _hoisted_2 = { class: "status-body" };
const _hoisted_3 = { class: "metric-grid" };
const _hoisted_4 = { class: "metric" };
const _hoisted_5 = { class: "metric-value tx" };
const _hoisted_6 = { class: "metric" };
const _hoisted_7 = { class: "metric-value rx" };
const _hoisted_8 = { class: "metric" };
const _hoisted_9 = { class: "metric-value err" };
const _hoisted_10 = { class: "metric" };
const _hoisted_11 = { class: "metric-value warn" };
const _hoisted_12 = { class: "rate-row" };
const _hoisted_13 = { class: "rtt-row" };
const _hoisted_14 = { class: "rtt-values" };
const _hoisted_15 = {
    key: 1,
    class: "fields-empty"
};
const _hoisted_16 = { class: "mono" };
import { computed } from 'vue';
import { useStore } from 'vuex';
export default /*@__PURE__*/ _defineComponent({
    __name: 'StatusPanel',
    props: {
        channel: {}
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const stats = computed(() => store.getters[`${props.channel}/stats`]);
        const successRate = computed(() => store.getters[`${props.channel}/successRate`]);
        const lastError = computed(() => store.getters[`${props.channel}/lastError`]);
        const fields = computed(() => store.getters[`${props.channel}/lastFrameFields`]);
        const rateStatus = computed(() => {
            if (stats.value.sent === 0)
                return undefined;
            if (successRate.value >= 95)
                return 'success';
            if (successRate.value >= 70)
                return 'warning';
            return 'exception';
        });
        function reset() {
            store.dispatch(`${props.channel}/resetStats`);
        }
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_progress = _resolveComponent("el-progress");
            const _component_el_tag = _resolveComponent("el-tag");
            const _component_el_alert = _resolveComponent("el-alert");
            const _component_el_divider = _resolveComponent("el-divider");
            const _component_el_table_column = _resolveComponent("el-table-column");
            const _component_el_table = _resolveComponent("el-table");
            const _component_el_card = _resolveComponent("el-card");
            return (_openBlock(), _createBlock(_component_el_card, { class: "mb-card" }, {
                header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "card-title" }, "通信状态", -1)),
                        _createVNode(_component_el_button, {
                            size: "small",
                            text: "",
                            type: "primary",
                            onClick: reset
                        }, {
                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                                _createTextVNode("重置统计", -1)
                            ])),
                            _: 1,
                            __: [0]
                        })
                    ])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, _toDisplayString(stats.value.sent), 1),
                                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "metric-label" }, "发送", -1))
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, _toDisplayString(stats.value.received), 1),
                                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "metric-label" }, "成功", -1))
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, _toDisplayString(stats.value.errors), 1),
                                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "metric-label" }, "错误", -1))
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, _toDisplayString(stats.value.timeouts), 1),
                                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "metric-label" }, "超时", -1))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "rate-label" }, "成功率", -1)),
                            _createVNode(_component_el_progress, {
                                percentage: successRate.value,
                                status: rateStatus.value,
                                "stroke-width": 10,
                                style: { "flex": "1" }
                            }, null, 8, ["percentage", "status"])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _cache[7] || (_cache[7] = _createElementVNode("span", null, "响应时间", -1)),
                            _createElementVNode("span", _hoisted_14, [
                                _createVNode(_component_el_tag, {
                                    size: "small",
                                    type: "info"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("当前 " + _toDisplayString(stats.value.lastRttMs) + "ms", 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_tag, {
                                    size: "small",
                                    type: "info"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("最小 " + _toDisplayString(stats.value.minRttMs) + "ms", 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_tag, {
                                    size: "small",
                                    type: "info"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("最大 " + _toDisplayString(stats.value.maxRttMs) + "ms", 1)
                                    ]),
                                    _: 1
                                })
                            ])
                        ]),
                        (lastError.value)
                            ? (_openBlock(), _createBlock(_component_el_alert, {
                                key: 0,
                                title: lastError.value,
                                type: "error",
                                closable: false,
                                "show-icon": "",
                                class: "error-alert"
                            }, null, 8, ["title"]))
                            : _createCommentVNode("", true),
                        _createVNode(_component_el_divider, { "content-position": "left" }, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createElementVNode("span", { class: "divider-text" }, "报文字段解析", -1)
                            ])),
                            _: 1,
                            __: [8]
                        }),
                        (fields.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, "收到响应后，各字段含义会在此逐条列出"))
                            : (_openBlock(), _createBlock(_component_el_table, {
                                key: 2,
                                data: fields.value,
                                size: "small",
                                border: "",
                                class: "field-table"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_el_table_column, {
                                        prop: "name",
                                        label: "字段",
                                        width: "96"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                        label: "值",
                                        width: "128"
                                    }, {
                                        default: _withCtx(({ row }) => [
                                            _createElementVNode("span", _hoisted_16, _toDisplayString(row.hex), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                        prop: "description",
                                        label: "说明",
                                        "min-width": "180",
                                        "show-overflow-tooltip": ""
                                    })
                                ]),
                                _: 1
                            }, 8, ["data"]))
                    ])
                ]),
                _: 1
            }));
        };
    }
});
